import { isSuccessfulPayment, findContactForPayment } from "./metrics";

function isOrderCompleted(order) {
  const st = String(order?.status ?? order?.state ?? "").toLowerCase();
  return ["complete", "completed", "paid", "succeeded", "delivered"].includes(st) || order?.completed === true;
}

export function contactHasCompletedOrder(contact, orders = [], payments = []) {
  if (!contact) return false;
  for (const o of orders) {
    if (!isOrderCompleted(o)) continue;
    const uid = o.user_id ?? o.userId ?? o.contactId ?? o.contact_id;
    if (uid && (String(uid) === String(contact.id) || String(uid) === String(contact.firebaseUid || ""))) return true;
    const email = (contact.email || "").toLowerCase();
    const oEmail = (o.email || o.user_email || "").toLowerCase();
    if (email && oEmail && email === oEmail) return true;
  }
  for (const p of payments) {
    if (!isSuccessfulPayment(p)) continue;
    const c = findContactForPayment([contact], p);
    if (c?.id === contact.id) return true;
  }
  if (contact.stage === "paid_customer") return true;
  return false;
}

export function orderStatusLabel(contact, orders, payments) {
  return contactHasCompletedOrder(contact, orders, payments) ? "Order completed" : "No order yet";
}
